import { useNavigate } from 'react-router';
import { useEffect, useState } from 'react';

const cardData = [
  { char: '4', icon: '◈', tone: 'var(--primary)' },
  { char: '0', icon: '◉', tone: 'var(--info, #6366f1)' },
  { char: '4', icon: '◎', tone: 'var(--success, #16a34a)' },
];

const infoCards = [
  { icon: '⚠️', label: 'Error Code', value: '404' },
  { icon: '🔍', label: 'Status', value: 'Not Found' },
  { icon: '↩️', label: 'Suggestion', value: 'Go Back' },
];

export default function NotFound() {
  const navigate = useNavigate();
  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setAnimated(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      className="min-h-screen flex flex-col font-sans"
      style={{ background: 'var(--bg-primary)', color: 'var(--text-primary)' }}
    >
      <main className="flex-1 flex flex-col items-center justify-center gap-10 px-6 py-16">
        <div className="flex gap-4 sm:gap-5">
          {cardData.map((card, i) => (
            <div
              key={i}
              style={{
                transitionDelay: `${i * 80}ms`,
                background: `linear-gradient(145deg, ${card.tone}, color-mix(in srgb, ${card.tone} 65%, #0f172a))`,
              }}
              className={`
                relative w-36 h-28 sm:w-44 sm:h-32 rounded-2xl
                overflow-hidden flex flex-col justify-end p-4 shadow-xl
                transition-all duration-500
                ${animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}
              `}
            >
              <div className="absolute -top-5 -right-5 w-24 h-24 rounded-full bg-white/10" />
              <div className="absolute top-7 right-4 w-12 h-12 rounded-full bg-white/10" />
              <span className="relative z-10 text-white/90 text-base mb-1 leading-none">
                {card.icon}
              </span>
              <span className="relative z-10 text-white text-5xl sm:text-6xl font-extrabold leading-none tracking-tight">
                {card.char}
              </span>
            </div>
          ))}
        </div>

        <div
          className={`
            text-center max-w-md
            transition-all duration-700 delay-300
            ${animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'}
          `}
        >
          <h1
            className="text-3xl sm:text-4xl font-extrabold mb-3 tracking-tight"
            style={{ color: 'var(--text-primary)' }}
          >
            Page Not Found
          </h1>
          <p
            className="text-sm sm:text-base leading-relaxed"
            style={{ color: 'var(--text-secondary)' }}
          >
            Looks like this test case doesn&apos;t exist in our framework.
            <br />
            The page you&apos;re looking for may have been moved or deleted.
          </p>
        </div>

        <div
          className={`
            flex flex-wrap justify-center gap-4
            transition-all duration-700 delay-500
            ${animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}
          `}
        >
          {infoCards.map((info, i) => (
            <div
              key={i}
              className="rounded-2xl px-8 py-5 flex flex-col items-center gap-1 min-w-[130px]"
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--border)',
                boxShadow: 'var(--shadow-md)',
              }}
            >
              <span className="text-2xl">{info.icon}</span>
              <span
                className="text-[10px] font-semibold uppercase tracking-widest mt-1"
                style={{ color: 'var(--text-muted)' }}
              >
                {info.label}
              </span>
              <span className="text-xl font-bold" style={{ color: 'var(--text-primary)' }}>
                {info.value}
              </span>
            </div>
          ))}
        </div>

        <div
          className={`
            flex flex-wrap justify-center gap-4
            transition-all duration-700 delay-700
            ${animated ? 'opacity-100' : 'opacity-0'}
          `}
        >
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="px-8 py-3 rounded-xl text-sm font-semibold text-white transition-all duration-150 hover:-translate-y-0.5 active:translate-y-0"
            style={{ background: 'var(--primary)', boxShadow: 'var(--shadow-md)' }}
          >
            ← Go Back
          </button>
          <button
            type="button"
            onClick={() => navigate('/dashboard')}
            className="px-8 py-3 rounded-xl text-sm font-semibold transition-all duration-150 hover:-translate-y-0.5 active:translate-y-0"
            style={{
              background: 'var(--surface)',
              color: 'var(--primary)',
              border: '2px solid var(--primary)',
            }}
          >
            Go to Dashboard
          </button>
        </div>
      </main>
    </div>
  );
}
